var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { getAnnotationEvents, getAnnotationProcedures } from './annotations';
import { getHotspotsProcedures, getHotspotsEvents } from './hotspots';
import { MessageEnum } from '../models/message.enum';
import { ToggleLabels } from 'src/app/engine/state/engine.actions';
export function getLabelsEvents(human, store) {
    return __spread(getAnnotationEvents(human, store), getHotspotsEvents(human, store));
}
export function getLabelsProcedures(Human, store, labelsService) {
    return __spread(getAnnotationProcedures(Human, store, labelsService), getHotspotsProcedures(Human, store, labelsService), [
        // label procedures
        {
            procName: MessageEnum.LabelsSetEnabled,
            aliases: [MessageEnum.AnnotationsSetEnabled],
            actionFn: function (params) {
                store.dispatch(new ToggleLabels(params.enable));
            }
        }
    ]);
}
